angular.module('unica_event_tag.event_tag_services')

.factory('EventTagDeleteService', function ($http, getBaseApiURL) {

	var eventTagDeleteService = {};

	eventTagDeleteService.delete = function (eventTagId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/event-tag/delete/' + eventTagId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};



	return eventTagDeleteService;
});